vs-content-card-grid {
  --font-family: "Visa Dialect", sans-serif;
  display: block;
  font-family: var(--font-family);
  box-sizing: border-box;
}

.vs-content-card-grid-theme-light {
  --bg-color: #ffffff;
  --tab-bg-color: transparent;
  --tab-bg-color-active: #1a1a1a;
  --tab-text-color: #1a1a1a;
  --tab-text-color-active: #ffffff;
  --tab-text-border-color: #1a1a1a26;
  --tab-icon-bg-color: #f7f7f7;
  --tab-icon-color: #1a1a1a;
  --button-secondary-bg: transparent;
  --button-secondary-text: #1a1a1a;
  --button-secondary-hover-text: #ffffff;
  --button-secondary-bg-hover: #1a1a1a;
  --button-secondary-border: #1a1a1a;
}

.vs-content-card-grid-theme-dark {
  --bg-color: #1a1a1a;
  --tab-bg-color: transparent;
  --tab-bg-color-active: #ffffff;
  --tab-text-color: #ffffff;
  --tab-text-color-active: #1a1a1a;
  --tab-text-border-color: #ffffff33;
  --tab-icon-bg-color: #2c2c2c;
  --tab-icon-color: #ffffff;
  --button-secondary-bg: transparent;
  --button-secondary-text: #ffffff;
  --button-secondary-hover-text: #1a1a1a;
  --button-secondary-bg-hover: #ffffff;
  --button-secondary-border: #ffffff;
}

.vs-content-card_content-card-grid {
  padding: 0 48px;
  background-color: var(--bg-color);
  position: relative;
  max-width: 1600px;
  margin: 0 auto;
  @media (max-width: 768px) {
    padding: 0 24px;

    vsr-title .vsr-title-headline {
      font-size: 32px; /* Mobile font size */
    }
  }
}

.vs-content-card_content-card-grid .vs-link-cta {
  min-height: auto !important;
}
.vs-content-card-grid-video-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;

  vsr-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.vs-content-card_content-card-grid > *:not(.vs-content-card-grid-video-container) {
  position: relative;
  z-index: 1;
}

/* Ensure consistent spacing for 4-up grid when 3-up is also used */
.vs-content-card__card-grid {
  max-width: 1600px;
  margin: 0 auto;
}
.vsr-title-block_container.vertical-center {
  max-width: 840px;
  margin: 0 auto;
}

.vs-content-card__card-grid {
  display: grid;
  justify-content: center;
  width: 100%;
  padding-bottom: 80px;

  &.vs-content-card_alignment-left {
    justify-content: flex-start;
  }

  &.vs-content-card_alignment-center {
    justify-content: center;
    @media (max-width: 480px) {
      justify-content: start;
    }
  }

  &.vs-content-card_alignment-right {
    justify-content: flex-end;
  }

  // Below 992px - maintain existing behavior for all card counts
  @media (max-width: 991px) {
    grid-template-columns: repeat(auto-fit, minmax(0, 300px));
    gap: 30px;
  }

  // 992px+ with less than 4 cards - center them with fixed gaps, responsive card width
  &.cards-center {
    @media (min-width: 992px) and (max-width: 1100px) {
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 32px;
      justify-content: center;
      margin: 0 auto;
    }

    @media (min-width: 1101px) and (max-width: 1199px) {
      grid-template-columns: repeat(auto-fit, 300px);
      gap: 32px;
      justify-content: center;
      margin: 0 auto;
    }

    @media (min-width: 1200px) and (max-width: 1299px) {
      grid-template-columns: repeat(auto-fit, 300px);
      gap: 48px;
      justify-content: center;
      margin: 0 auto;
    }

    @media (min-width: 1300px) {
      grid-template-columns: repeat(auto-fit, 300px);
      gap: 48px;
      justify-content: center;
      margin: 0 auto;
    }
  }

  // 992px+ with 4+ cards - fixed gaps, responsive card width, max 4 per row
  &.cards-grid {
    max-width: 1600px;
    @media (min-width: 992px) and (max-width: 1100px) {
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 32px;
      //max-width: calc(4 * 220px + 3 * 32px);
      margin: 0 auto;
    }
    @media (min-width: 1101px) and (max-width: 1199px) {
      grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
      gap: 32px;
      //max-width: calc(4 * 250px + 3 * 32px);
      margin: 0 auto;
    }
    @media (min-width: 1200px) and (max-width: 1299px) {
      grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
      gap: 48px;
      //max-width: calc(4 * 270px + 3 * 48px);
      margin: 0 auto;
    }

    @media (min-width: 1300px) {
      grid-template-columns: repeat(4, 1fr);
      gap: 48px;
      max-width: 1600px;
      margin: 0 auto;
    }
  }

  @media (max-width: 480px) {
    gap: 30px 0;
    padding-bottom: 48px;
    grid-template-columns: 1fr;
    justify-content: start;
  }

  .vs-content-card__card {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  // Override fixed widths in card components for responsive behavior
  @media (min-width: 992px) {
    vsr-card {
      max-width: none !important;
      width: 100% !important;

      .vsr-card {
        max-width: none !important;
        width: 100% !important;
      }

      .vsr-card__image-container {
        width: 100% !important;
      }

      .vsr-card__image {
        max-width: none !important;
        width: 100% !important;
      }
    }

    vsr-product-card {
      max-width: none !important;
      width: 100% !important;

      .vsr-product-card {
        max-width: none !important;
        width: 100% !important;
      }

      .vsr-product-card__image-container {
        width: 100% !important;
      }

      .vsr-product-card__image {
        max-width: none !important;
        width: 100% !important;
      }
    }

    vsr-icon-card {
      max-width: none !important;
      width: 100% !important;

      .vsr-icon-card_container {
        max-width: none !important;
        width: 100% !important;
      }
    }
  }
}

.vs-content-card_load-more-container {
  display: flex;
  justify-content: center;
  margin: 80px 0px;
  @media (max-width: 480px) {
    margin: 48px;
    justify-content: start;
  }
}

.vs-content-card__load-more-button {
  font-family: "Visa Dialect", sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--button-secondary-text);
  background: transparent;
  border: 1px solid var(--button-secondary-border);
  border-radius: 1000px;
  padding: 0.75rem 2rem;
  cursor: pointer;
  transition: all 0.2s ease;
  @media (max-width: 480px) {
    width: 100%;
  }
}

.vs-content-card__load-more-button:hover {
  background-color: var(--button-secondary-bg-hover);
  color: var(--button-secondary-hover-text);
}

.vs-content-card__card-fixed-image {
  height: 300px;
  background-color: var(--color-bg-secondary);
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 900px) {
  .vs-content-card__card-fixed-image {
    width: auto;
  }
}

.vs-content-card__card-fixed-image img {
  width: 170px;
  height: 170px;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transition:
    width 0.2s ease-in-out,
    height 0.2s ease-in-out;
}

.vs-content-card__card:hover .vs-content-card__card-fixed-image img {
  width: 180px;
  height: 180px;
}

.vs-content-card__card:hover .vs-content-card__card-title {
  color: #1434cb;
}

.vs-content-card_card-action-button:hover {
  text-decoration: none;
  color: #1434cb;
}

.vs-content-card_card-action-button:hover svg {
  transition:
    width 0.2s ease-in-out,
    height 0.2s ease-in-out;
  margin-left: 8px;
}

.vs-content-card__image {
  object-fit: cover;
}

.vs-content-card__content {
  word-wrap: break-word;
}

/* Video styling for cards with vsr-card component */
.vs-content-card__video-wrapper {
  position: relative;
  width: 300px;
  max-width: 300px;
  @media (max-width: 480px) {
    max-width: none;
    width: 100%;
  }

  /* Hide the image container of the card since we're using video instead */
  .vsr-card__image-container {
    display: none;
  }

  /* Position the vsr-card component to show only the content part */
  vsr-card {
    display: block;
    width: 100%;
  }

  /* Style the video element */
  .vs-content-card__video-element {
    width: 100%;
    height: 400px;
    object-fit: cover;
    display: block;
    background: #f6f6f6;
    overflow: hidden;
    border-radius: 2px;
  }
}

/* Legacy video styles - kept for backward compatibility */
.vs-content-card__video-container {
  position: relative;
  width: 300px;
  height: 400px;
  overflow: hidden;
  border-radius: 2px;

  vsr-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.vs-content-card__video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 20px;
  box-sizing: border-box;
  transition: background 0.3s ease;
}

.vs-content-card__video-link {
  text-decoration: none;
  color: var(--tab-text-color);
  display: block;
  width: 100%;
  cursor: pointer;

  &:hover .vs-content-card__video-overlay {
    background: transparent;
  }

  &:hover .vs-content-card__video-element {
    transform: scale(1.03);
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }
}

/* Make title change color when hovering over the video only when it has a link */
.vs-content-card__video-wrapper.has-card-link:hover .vsr-card__title {
  color: var(--color-title-hover);
}

.vs-content-card__video-wrapper.has-card-link:hover .vsr-card__title a {
  color: var(--color-title-hover);
}

.vs-content-card__video-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 10px 0;
  color: var(--tab-text-color);
}

.vs-content-card__video-description {
  font-size: 14px;
  color: var(--tab-text-color);
  margin: 0;
}
.vs-content-card__view-all-card {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--tab-icon-bg-color);
  width: 100%;
  @media (max-width: 991px) {
    width: 300px;
  }
  @media (max-width: 480px) {
    width: auto;
  }

  // Default card heights based on aspect ratios (matching vsr-card image container)
  &.aspect-ratio-1-1 {
    aspect-ratio: 1 / 1;
    height: auto;
  }

  &.aspect-ratio-3-4 {
    aspect-ratio: 3 / 4;
    height: auto;
  }

  &.aspect-ratio-4-3 {
    aspect-ratio: 4 / 3;
    height: auto;
  }

  &.aspect-ratio-4-5 {
    aspect-ratio: 4 / 5;
    height: auto;
  }

  &.aspect-ratio-16-9 {
    aspect-ratio: 16 / 9;
    height: auto;
  }

  &.b-radius {
    border-radius: 2%;
  }
}

.vs-content-card__product_view-all-card {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--tab-icon-bg-color);
  width: 100%;
  @media (max-width: 991px) {
    width: 300px;
  }
  @media (max-width: 480px) {
    width: auto;
  }

  // Product card heights based on aspect ratios and variants
  &.aspect-ratio-1-1 {
    aspect-ratio: 1 / 1;
    height: auto;
  }

  &.aspect-ratio-3-4 {
    aspect-ratio: 3 / 4;
    height: auto;
  }

  &.aspect-ratio-4-3 {
    aspect-ratio: 4 / 3;
    height: auto;
  }

  &.aspect-ratio-4-5 {
    aspect-ratio: 4 / 5;
    height: auto;
  }

  &.aspect-ratio-16-9 {
    aspect-ratio: 16 / 9;
    height: auto;
  }

  // Product card variant heights (matching vsr-product-card exactly)
  &.variant1:not([class*="aspect-ratio"]) {
    height: calc(400px + 16px + 80px); // image height + margin + content area
  }

  &.variant2:not([class*="aspect-ratio"]) {
    height: calc(169px + 16px + 80px); // image height + margin + content area
  }

  // Default product card height (fixed image container) - when no variant or aspect ratio
  &:not(.variant1):not(.variant2):not([class*="aspect-ratio"]) {
    height: calc(300px + 16px + 80px); // 300px fixed + margin + content
  }

  &.b-radius {
    border-radius: 2%;
  }
}

.arrow-right {
  position: relative;
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  align-self: center;

  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 3px;
    width: 8px;
    height: 8px;
    border-top: 2px solid currentColor;
    border-right: 2px solid currentColor;
    transform: translateY(-50%) rotate(45deg);
  }

  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    width: 12px;
    height: 2px;
    background-color: currentColor;
    transform: translateY(-50%);
  }
}

.vs-content-card__view-all-link {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  color: var(--button-secondary-text);
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
  cursor: pointer;
  transition:
    gap 0.2s,
    color 0.2s;

  .arrow-right {
    align-self: flex-start; // Override the center alignment
    flex-shrink: 0; // Prevent shrinking
    margin-top: 2px; // Align with text baseline
    margin-left: 0; // Remove default margin
    color: inherit; // Inherit color from parent link
  }

  &:hover {
    color: #1434cb;
    text-decoration: none;
    gap: 1rem;
    .arrow-right {
      color: #1434cb;
    }
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.vs-link-cta.vs-link-same-window.vs-link-inline {
  color: #1a1a1a;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: #1434cb;
  }
}

.vs-link-cta.vs-link-new-window.vs-link-inline {
  color: #1a1a1a;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: #1434cb;
  }
}
